import React from 'react';
import { useTranslation } from 'react-i18next';
import { IonIcon, IonItem, IonText } from '@ionic/react';
import { PaymentMethod } from '../../services/types/apitypes';
import './PaymentItem.css';
import {AdditionalPaymentMethod, AdditionalPaymentMethods} from "./PaymentsList";

type PaymentItemProps = CardPaymentItemProps | AdditionalPaymentItemProps;

type AdditionalPaymentItemProps = {
  otherPaymentType: AdditionalPaymentMethod;
  click: (p: AdditionalPaymentMethod) => void;
  payment?: never;
};

type CardPaymentItemProps = {
  payment: PaymentMethod;
  click: (p: PaymentMethod) => void;
  otherPaymentType?: never;
};


export default function PaymentItem({ payment, click, otherPaymentType }: PaymentItemProps) {
  const [t] = useTranslation('global');

  const getPaymentNickname = () => {
    if (payment) return payment.nickname;

    const otherPaymentNames = {
      "GOOGLE": "Pay with Google",
      "APPLE": "Pay with Apple",
    } as Record<AdditionalPaymentMethod, string>

    return otherPaymentNames[otherPaymentType];
  }

  const getPaymentIconName = () => {
    if (payment) return payment.creditCardType.toLowerCase()

    const otherPaymentIcons = {
      "GOOGLE": "google_pay",
      "APPLE": "apple_pay",
    } as Record<AdditionalPaymentMethod, string>

    return otherPaymentIcons[otherPaymentType];
  }

  const handleClick = () => {
    if (payment) {
      return click(payment);
    }
    return click(otherPaymentType);
  }

  return (
    <IonItem
      lines="none"
      className="ion-no-padding ion-pt-1 pseudo-select payment-select"
      button={true}
      detail={true}
      onClick={() => {
        handleClick();
      }}
    >
      <IonIcon
        slot="start"
        className="icon-payment-big"
        src={'assets/icon/' + getPaymentIconName() + '.svg'}
      ></IonIcon>
      <div className="payment-box-cc">
        <IonText className="payment-text-cc payment-text-ccc no-translate">
          {getPaymentNickname()}
        </IonText>
        {payment?.isDefault && (
          <IonText className="payment-text-cc" color="success">
            &nbsp;({t('payments.default')})
          </IonText>
        )}
        <br />
        <IonText className="payment-text-cc payment-text-ccc">
          {payment?.maskedPan}
        </IonText>
      </div>
    </IonItem>
  );
}
